import { createContext, Dispatch, SetStateAction } from 'react';
import { UploaderProps } from 'components/Dropzone/utils';
import utils from 'utils';

type DataRoomUploadContextProps = {
  isUploading: boolean;
  isDragActive: boolean;
  dropzoneContainerProps: any;
  currentlyUploading: UploaderProps[];
  setUploaderProps: Dispatch<SetStateAction<Record<string, UploaderProps>>>;
  onUploadClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export default createContext<DataRoomUploadContextProps>({
  isUploading: false,
  isDragActive: false,
  dropzoneContainerProps: null,
  currentlyUploading: [],
  setUploaderProps: utils.noop,
  onUploadClick: utils.noop,
});
